module.exports = __webpack_public_path__ + "images/file_gif_50bf0d9.gif";